import type { AbilityBuilder, MongoQuery } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { TaskList } from '~/types/taskList.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineTaskListAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can, cannot } = abilityBuilder

  can('read', 'task-lists-id')

  type TaskListQuery = MongoQuery<TaskList>
  type TaskListKeys = keyof TaskList | Array<keyof TaskList>
  can(['create', 'update'], 'task-list')

  const roles = userRoles(user)

  if (roles.administrator) {
    can(['create', 'read', 'update', 'delete', 'restore'], 'task-list')
  }
  if (roles.client_lead) {
    can(['delete', 'restore'], 'task-list')
  }
  else {
    cannot(['create', 'update'], 'task-list', ['isCompleted', 'timeLimitSec', 'notificationThresholds'] as TaskListKeys, {
      'project.leads.id': {
        $ne: user.id,
      },
    } as TaskListQuery)

    can(['delete', 'restore'], 'task-list', {
      'project.leads.id': user.id,
    } as TaskListQuery)
  }
}
